module.exports = __webpack_public_path__ + "static/media/helexia_qr_icon.43f10cf3.svg";